import { cartApi, getTranslation, updateCart } from '../helpers';

const selectors = {
  root: '[data-buy-button]',
  addToCartButton: '[data-add-to-cart-item]',
  addToCartText: '[data-add-to-cart-text]',
};

const INIT_ATTR = 'data-buy-button-init';
const BUTTON_RESET_DELAY = 2000;
let sectionEventsBound = false;

function initBuyButton(root) {
  if (root.hasAttribute(INIT_ATTR)) {
    return;
  }

  const button = root.querySelector(selectors.addToCartButton);

  if (!button) {
    return;
  }

  root.setAttribute(INIT_ATTR, '');

  let originalButtonTexts = [];
  const textElements = button.querySelectorAll(selectors.addToCartText);

  if (textElements.length) {
    originalButtonTexts = Array.from(textElements).map(element =>
      element.textContent.trim(),
    );
  }

  button.addEventListener('click', e => {
    e.preventDefault();

    const variantId = button.dataset.variantId;

    if (!variantId || button.disabled) {
      return;
    }

    toggleLoading(button, true, getTranslation('products.adding'));

    cartApi
      .add({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: 1,
          },
        ],
      })
      .then(response => {
        toggleLoading(button, false, getTranslation('products.added'));

        if (response.sections) {
          updateCart({ sections: response.sections, openCart: true });
        }

        setTimeout(() => {
          restoreButtonText(button, originalButtonTexts);
        }, BUTTON_RESET_DELAY);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
        toggleLoading(button, false, getTranslation('products.error'));

        setTimeout(() => {
          restoreButtonText(button, originalButtonTexts);
        }, BUTTON_RESET_DELAY);
      });
  });
}

function restoreButtonText(button, originalButtonTexts) {
  if (!button || button.disabled || !originalButtonTexts.length) {
    return;
  }

  const textElements = button.querySelectorAll(selectors.addToCartText);

  textElements.forEach((element, index) => {
    if (originalButtonTexts[index]) {
      element.textContent = originalButtonTexts[index];
    }
  });
}

function toggleLoading(button, isLoading, text) {
  if (!button) {
    return;
  }

  button.disabled = isLoading;

  if (text) {
    button.querySelectorAll(selectors.addToCartText).forEach(element => {
      element.textContent = text;
    });
  }
}

export default function initBuyButtons(container = document) {
  if (!sectionEventsBound) {
    document.addEventListener('shopify:section:load', event => {
      initBuyButtons(event.target);
    });
    sectionEventsBound = true;
  }

  container.querySelectorAll(selectors.root).forEach(initBuyButton);
}
